/** Joins class names, skipping falsy entries: `cx(styles.btn, size === 'sm' && styles.sm)`. */
export function cx(...names: readonly (string | false | null | undefined)[]): string {
  return names.filter(Boolean).join(' ');
}
